import React from 'react'
import { useUserSettings } from '@dustin-web/microsite-components/src/hooks'
import { getTwoLetterISOLanguageName } from '@dustin-web/microsite-config/src'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Site } from '@dustin-web/microsite-config'

type Props = {
  site: Site
}

const FooterNewsletterSwitcher = ({ site }: Props) => {
  const { language } = useUserSettings()
  const { translate } = useTranslations()
  const twoLetterISOLanguageName =
    getTwoLetterISOLanguageName(language) === 'nb' ? 'no' : getTwoLetterISOLanguageName(language)

  switch (site) {
    case 'DustinSweden':
      return (
        <div
          className="col-12 col-md-12 c-form c-form--grid c-form--dark"
          style={{ display: 'none' }}
          data-infunnelapps-form-id="62684db1a96a06000cd5b5a6"
          data-fields="sales_group=,marketing_group=,asset=Subscribe_B2B_SE_Footer,business_type=B2B,lead_source=Subscribe_B2B_SE_Footer,interest_category=Subscribe_B2B_SE_Footer,site_id=1"
          data-lang={twoLetterISOLanguageName}
          data-form-title=""
          data-redirect-url="/nyhetsbrev/tack-for-din-anmalan/"
          data-submit-name={translate('Subscribe')}>
          <div style={{ height: '300px', width: '100%' }}></div>
        </div>
      )
    case 'DustinNorway':
      return (
        <div
          className="col-12 col-md-12 c-form c-form--grid c-form--dark"
          style={{ display: 'none' }}
          data-infunnelapps-form-id="62684db1a96a06000cd5b5a6"
          data-fields="sales_group=,marketing_group=,asset=Subscribe_B2B_NO_Footer,business_type=B2B,lead_source=Subscribe_B2B_NO_Footer,interest_category=Subscribe_B2B_NO_Footer,site_id=3"
          data-lang={twoLetterISOLanguageName}
          data-form-title=""
          data-redirect-url="/nyhetsbrev/takk-for-pameldingen-din/"
          data-submit-name={translate('Subscribe')}>
          <div style={{ height: '300px', width: '100%' }}></div>
        </div>
      )
    case 'DustinDenmark':
      return (
        <div
          className="col-12 col-md-12 c-form c-form--grid c-form--dark"
          style={{ display: 'none' }}
          data-infunnelapps-form-id="62684db1a96a06000cd5b5a6"
          data-fields="sales_group=,marketing_group=,asset=Subscribe_B2B_DK_Footer,business_type=B2B,lead_source=Subscribe_B2B_DK_Footer,interest_category=Subscribe_B2B_DK_Footer,site_id=5"
          data-lang={twoLetterISOLanguageName}
          data-form-title=""
          data-redirect-url="/nyhedsbrev/tak-for-din-tilmelding/"
          data-submit-name={translate('Subscribe')}>
          <div style={{ height: '300px', width: '100%' }}></div>
        </div>
      )
    case 'DustinFinland':
      return (
        <div
          className="col-12 col-md-12 c-form c-form--grid c-form--dark"
          style={{ display: 'none' }}
          data-infunnelapps-form-id="62684db1a96a06000cd5b5a6"
          data-fields="sales_group=,marketing_group=,asset=Subscribe_B2B_FI_Footer,business_type=B2B,lead_source=Subscribe_B2B_FI_Footer,interest_category=Subscribe_B2B_FI_Footer,site_id=7"
          data-lang={twoLetterISOLanguageName}
          data-form-title=""
          data-redirect-url="/uutiskirje/kiitos-ilmoituksestasi/"
          data-submit-name={translate('Subscribe')}>
          <div style={{ height: '300px', width: '100%' }}></div>
        </div>
      )
    case 'DustinNetherlands':
      return (
        <div
          className="col-12 col-md-12 c-form c-form--grid c-form--dark"
          style={{ display: 'none' }}
          data-infunnelapps-form-id="62684db1a96a06000cd5b5a6"
          data-fields="sales_group=,marketing_group=,asset=Subscribe_B2B_NL_Footer,business_type=B2B,lead_source=Subscribe_B2B_NL_Footer,interest_category=Subscribe_B2B_NL_Footer,site_id=9"
          data-lang={twoLetterISOLanguageName}
          data-form-title=""
          data-redirect-url="https://www.dustin.nl/nieuwsbrief/bedankt"
          data-submit-name={translate('Subscribe')}>
          <div style={{ height: '300px', width: '100%' }}></div>
        </div>
      )
    default:
      return null
  }
}

export default FooterNewsletterSwitcher
